import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  mccList: [],
  isAddMCCModalOpen: false,
  pageCount: 0,
  page: 1,
  totalItems: 0,
  itemsPerPage: 10,
  searchFilters: {
    search: "",
    sortBy: "id",
    sortColumn: "ASC",
  },
  recordToEdit: null,
  selectedMcc: [],
  bulkDeleteModal: false,
  bulkProcessorModal: false,
  bulkAddendumsModal: false,
  bulkRemoveProcessorModal: false,
  bulkRemoveAddendumsModal: false,
};

const useMccStore = create(
  devtools((set) => ({
    ...initialState,

    setMccList: (mccList) => set({ mccList }),
    setIsAddMCCModalOpen: (isAddMCCModalOpen) => set({ isAddMCCModalOpen }),
    setPageCount: (pageCount) => set({ pageCount }),
    setPage: (page) => set({ page }),
    setSearchFilters: (searchFilters) => set({ searchFilters }),
    setRecordToEdit: (recordToEdit) => set({ recordToEdit }),
    setSelectedMcc: (selectedMcc) => set({ selectedMcc }),
    setBulkDeleteModal: (bulkDeleteModal) => set({ bulkDeleteModal }),
    setBulkProcessorModal: (bulkProcessorModal) => set({ bulkProcessorModal }),
    setBulkAddendumsModal: (bulkAddendumsModal) => set({ bulkAddendumsModal }),
    setBulkRemoveProcessorModal: (bulkRemoveProcessorModal) => set({ bulkRemoveProcessorModal }),
    setBulkRemoveAddendumsModal: (bulkRemoveAddendumsModal) => set({ bulkRemoveAddendumsModal }),
    setTotalItems: (totalItems) => set({ totalItems }),
    setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),

    reset: () => set(initialState),
  })),
);

export default useMccStore;
